export default __webpack_public_path__ + "static/media/Gshar-Products34.73510dd9.jpg";